export const DEVICE_LOCK_REQUIRED_BODY =
  'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.';

export const ENGINEERING_LOCK_WARNING_BODY =
  'The Device has custom configurations set by EPIK Engineering and is locked for editing and changes. Please contact EPIK Engineering if changes or troubleshooting is needed for this device.';

export const resolveEngineeringLockState = (engineeringLockState, box) =>
  engineeringLockState ?? box?.engineeringLock ?? null;

export const isEngineeringLockEnabled = (engineeringLockState, box) =>
  Boolean(resolveEngineeringLockState(engineeringLockState, box));

export const isEngineeringLockActiveOnPage = () => {
  if (typeof document === 'undefined') return false;
  if (document.querySelector('[data-engineering-lock-active="true"]')) return true;

  const lockLabels = document.querySelectorAll('.lock-container .locked-text');
  return Array.from(lockLabels).some(el =>
    el.textContent?.includes('Engineering Lock Enabled'),
  );
};

export const getHasEngineerPermission = user =>
  user?.epikEngineering === true || user?.permissionsGroup === 'Engineering';

export const isNonEngineerUnderEngineeringLock = (
  user,
  engineeringLockState,
  box,
) => {
  const engineeringLockActive =
    isEngineeringLockEnabled(engineeringLockState, box) ||
    isEngineeringLockActiveOnPage();

  return engineeringLockActive && !getHasEngineerPermission(user);
};

export const getDeviceLockModalConfig = (
  user,
  engineeringLockState,
  box,
  confirmBtnText = 'Lock & Edit',
) => {
  if (isNonEngineerUnderEngineeringLock(user, engineeringLockState, box)) {
    return {
      bodyText: ENGINEERING_LOCK_WARNING_BODY,
      headerText: 'Warning',
      confirmBtnText,
      warning: true,
      ignoreConfirmButton: true,
      close: true,
      closeBtnText: 'Cancel',
    };
  }

  return {
    bodyText: DEVICE_LOCK_REQUIRED_BODY,
    headerText: 'Device Lock Required',
    confirmBtnText,
    warning: false,
    ignoreConfirmButton: false,
    close: 'No',
  };
};
